import Footer from 'components/global/footer';
import CaseStudy from 'components/home/CaseStudy';
import CheckoutOurPlatform from 'components/home/CheckoutOurPlatform';
import Clients from 'components/home/Clients';
import Hero from 'components/home/Hero';
import HowItWorks from 'components/home/HowItWorks';
import TopLocations from 'components/home/TopLocations';

const Home = () => {

    return (
        <div>
            <Hero />
            <Clients />
            <TopLocations />
            <HowItWorks />
            <CaseStudy />
            <CheckoutOurPlatform />
            <Footer />
        </div>
    )
}

export default Home